import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getAdminNav: () => NavRoute = () => ({
	name: 'Admin',
	security: sec => sec.manageUsers,
	children: [
		{
			name: 'Utility Providers',
			security: sec => sec.adminFeatures,
			exact: true,
			path: 'administration/utility-providers/utility-providers-list'
		},
		{
			name: 'Users',
			security: sec => sec.manageUsers,
			href: 'administration/users',
			children: [
				{
					name: 'User List',
					security: sec => sec.manageUsers,
					exact: true,
					path: 'administration/users',
				},
				{
					name: 'Global Audit History',
					security: sec => sec.manageUsers,
					exact: true,
					path: 'administration/global-audit-history',
				},
				{
					name: 'Login History',
					security: sec => sec.manageUsers,
					path: 'administration/users/login-history',
				},
			],
		},
		{
			name: 'Release Notes',
			security: sec => sec.adminFeatures,
			exact: true,
			path: 'administration/release-notes/release-notes-list'
		}
	]
});
		
